module.exports = __webpack_public_path__ + "static/media/future-autism-01.be93a98c.jpg";